/* eslint-disable react/react-in-jsx-scope */

import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import AuthenticatedRoutes from "routes/AuthenticatedRoutes";
import AnonymousRoutes from "routes/AnonymousRoutes";
import UserService from "services/UserService";
import anonymousRoutesJson from "routes/anonymousRoutesJson";


function App() {
	const anonymousRoutes = anonymousRoutesJson;
	let pathname:any = window.location.pathname
	pathname = pathname.split("/");
	pathname = pathname.filter((f:any) =>f!='' );
	// console.log(pathname,anonymousRoutes.includes(pathname[0]))
	return (
		<div className="App">
			<BrowserRouter>
				{anonymousRoutes.includes(pathname[0])?<AnonymousRoutes/>:(UserService.isLoggedIn() ? <AuthenticatedRoutes /> :null) }
			</BrowserRouter>
		</div>
	);
}

export default App;
